export const GENDER_OPTIONS = ['Masculino', 'Feminino', 'Prefiro não informar'];
